import { NonIdealState } from "@blueprintjs/core";
import { FGCustomPanel, FGSelectInput, FieldGroup } from "nsitools-react";
import * as React from "react";

import { ERequestState } from "../../../../api";
import { FGSRSHCheckboxInput, FGSRSHDateMaskInput } from "../../../../components";
import { useAuth } from "../../../../contexts";
import { useTl } from "../../../../hooks";
import { useReferential } from "../../../../hooks/useReferential";
import { ETLCodes } from "../../../../locales";
import { DrupalStepperButtonBloc } from "../../../common";
import { DrupalFormGenerator } from "../../../common/DrupalFormGenerator";
import { DrupalRequestTransientPersonGrid } from "./DrupalRequestTransientPersonGrid";

export interface IDrupalRshFormProps {
  dogOwnershipChangeRequestId: number;
  initialdata: any;
  loading: boolean;
}

export const DrupalRshForm: React.FunctionComponent<IDrupalRshFormProps> = ({ loading, initialdata }) => {
  const { user } = useAuth();
  const { t } = useTl();
  const [dogs, dloading] = useReferential(
    (a) => a.getOwnedDogs(user.userId, initialdata?.dogId ? initialdata.dogId : 0, null, null, null),
    true,
    []
  );

  return (
    <>
      <DrupalFormGenerator
        initialValues={initialdata}
        editMode={false}
        onSubmit={null}
        loading={loading}
        saving={false}
        hideButtons
      >
        <FieldGroup columns={2} fieldsetProps={{ divider: false, title: t(ETLCodes.RequestData) }}>
          <div>
            <FGSRSHDateMaskInput name="request.requestDate" label={t(ETLCodes.RequestDate)} />
            {initialdata?.request?.status === ERequestState.EXECUTED && (
              <FieldGroup columns={2}>
                <FGSRSHDateMaskInput name="request.executionDate" label={t(ETLCodes.ClosingDate)} />
              </FieldGroup>
            )}
            <FGSelectInput name="dogId" label={t(ETLCodes.Dog)} items={dogs} loading={dloading} />
            <FGSRSHCheckboxInput name="export" label={t(ETLCodes.Export)} />
          </div>
        </FieldGroup>

        {/* TODO: make component to only get info of selectedIds (no person search for secutiry reasons) <FGCustomPanel>
          {({ formik }) =>
            formik?.values?.dogId ? (
              <DrupalRequestTransientPersonGrid
                linkedIds={formik?.values?.ownerIds || null}
              />
            ) : (
              <NonIdealState
                icon="resolve"
                description={t(ETLCodes.PleaseSelectADogToEditOwners)}
              />
            )
          }
        </FGCustomPanel> */}
        <DrupalStepperButtonBloc backOnly={true} />
      </DrupalFormGenerator>
    </>
  );
};
